<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <b-card>

        <b-card-title class="text-end">
          <b-button variant="primary" class="mb-2" @click="incluirSolicitacao()"> 
            <i class="bx bx-plus"/> Solicitar Adiantamento
          </b-button>
        </b-card-title>

        <div class="d-flex justify-content-center" v-if="loading">
          <b-spinner
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner>
        </div>

        <b-table
          v-if="listaAdiantamento.length > 0"
          responsive="sm"
          :fields="camposListaAdiantamento"
          :items="listaAdiantamento"
          per-page="10"
          :current-page="currentPage"
          striped
        >
          <template v-slot:cell(detail)="data">
            <div class="d-flex">
              <b-button 
                @click="data.toggleDetails" 
                variant="success"
                data-v-step="22"
                class="me-2"
              >
                <i v-if="data.detailsShowing" class="mdi mdi-arrow-down-bold font-size-16"></i>
                <i v-else class="mdi mdi-arrow-right-bold font-size-16"></i>
              </b-button>

              <b-button
                variant="danger"
                @click="cancelarAdiantamento(data.item)"
                :disabled="loadingExcluir"
                v-if="data.item.st_adiantamento === 'S'"
              >
                <i class="mdi mdi-trash-can font-size-16"></i>
                <b-spinner small v-if="loadingExcluir"></b-spinner>
              </b-button>
            </div>
            
          </template>
          <template v-slot:cell(st_adiantamento)="data">
            <span
              class="badge badge-pill font-size-12"
              :class="'badge-soft-'+trataStatus(data.value).cor">
              {{trataStatus(data.value).value}}
            </span>
          </template>
          <template #row-details="data">
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column ps-2 pt-1">
                  <label> <strong>Finalidade do Uso</strong> </label>
                  <label> {{data.item.ds_detalhe_uso}} </label>
                </div> 
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column ps-2 pt-1">
                  <label><strong>Justificativa</strong></label>
                  <label>{{data.item.ds_justificativa}}</label>
                </div>
              </div>
            </div>
            <div class="accordion" role="tablist">
              <b-card 
                v-for="(justificativa, index) in data.item.gerdviag_adto_interacao
                  .filter(i => !(i.st_interacao === 'T' || i.st_interacao === 'V' || i.st_interacao === 'J'))
                  .slice().sort((a, b) => new Date(b.dt_usuinc) - new Date(a.dt_usuinc))" :key="index" no-body class="mb-1 mt-2">
                <b-card-header header-tag="header" class="p-1" role="tab" :style="index % 2 ? '' : 'background-color: white;'">
                  <h6 @click="abreFechaCollapse(justificativa.sq_gerdviag_adto_interacao)" variant="info" class="div-clickable mt-2" block>
                    <i class="mdi mdi-subdirectory-arrow-right" />
                    <strong>{{$tools.converteDataHora(justificativa.dt_usuinc)}} - {{trataStatus(justificativa.st_interacao).value}}</strong>
                  </h6>
                </b-card-header>
                <b-collapse :visible="ref == justificativa.sq_gerdviag_adto_interacao" role="tabpanel">
                  <b-card-body> 
                    <ul>
                      <li><strong>Valor Interação: </strong>{{$tools.converteReal(justificativa.vl_interacao)}}</li>
                      <li><strong>Status: </strong>{{trataStatus(justificativa.st_interacao).value}}</li>
                      <li><strong>Justificativa: </strong>{{justificativa.ds_interacao}}</li>
                      <li v-if="justificativa.st_interacao == 'A'"><strong>Previsão de Pagamento:</strong> {{$tools.converteData(justificativa.dt_venc)}}</li>
                    </ul>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>
        </b-table>

        <div class="row">
          <div class="d-flex justify-content-end px-1 mt-3">
            <div class="me-2 align-self-center mt-1">
              <router-link to="/cooperado/rdv">
                <b-button class="btn-lg">
                  Voltar
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
export default {
  components: {
    PageHeader
  },
  data(){
    return {
      title: "Listagem de adiantamentos",
      items: [
        {
          text: "RDV Digital",
        },
        {
          text:  "Listagem de adiantamentos",
          active: true,
        }
      ],
      currentPage:1,
      rows:0,
      rdvInfo:{},
      camposListaAdiantamento: [
        {
          key: "detail",
          label: ""
        },
        {
          key: "sq_gerdviag_adto",
          label: "ID",
          class: "alinharCelulaDireita",
        },
        {
          key: "dt_usuinc",
          label: "Data Solicitação",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value)
          },
        },
        {
          key: "vl_adiantamento",
          label: "Valor Solicitado",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value)
          },
        },
        {
          key: "vl_aprovado",
          label: "Valor Analisado",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value)
          },
        },
        {
          key: "st_adiantamento",
          label: "Status",
        },
      ],
      listaAdiantamento: [],
      camposListaJustificativas: [
        {
          key: "sq_gerdiavg_adto_interacao",
          label: "Ano Interação",
        },
        {
          key: "vl_interacao",
          label: "Valor Interação",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value)
          },
        },
        {
          key: "ds_interacao",
          label: "Descrição Adiantamento",
        },
        {
          key: "st_status",
          label: "Status",
        },
      ],
      ref:-1,
      loading:true,
      adtoAnalise: true,
      cabecalhoRdv: { cd_rdv: null },
      itemParaExcluir: null,
      loadingExcluir: false
    }
  },
  async created() {
    this.cabecalhoRdv.cd_rdv = this.$route.params.id; 

  this.listaAdiantamento = await this.buscarSolitacoes(this.$route.params.id);
  this.listaAdiantamento.forEach((el) => {
    if(el.st_adiantamento != 'A' && el.st_adiantamento != 'R'){
      this.adtoAnalise = false;
    }
  })
  this.loading = false;
},
  methods: {
    montaDetalhes(item){
      item.forEach(el => {
        if(el.status != "Aprovação do Tomador"){
          el._showDetails = true;
        }
      });
      return item
    },
    abreFechaCollapse(index){
      if(index == this.ref){
        this.ref = -1;
      }else{
        this.ref = index;
      }
    },
    buscarSolitacoes(cdRdv) {
      return this.$http.get('api/solicitacaoAdiantamento/buscarSolicitacao/' + cdRdv)
        .then((response) => response.data || [])
        .catch((err) => {
          console.log(err.response);
          return [];
        });
    },
    trataStatus(status){
      switch (status) {
        case "S":
          return {value: "Solicitado", cor:"warning"}
        case "U":
          return {value: "Em análise", cor:"warning"}
        case "T":
          return {value: "Em análise", cor:"warning"}
        case "V":
          return {value: "Em análise", cor:"warning"}
        case "J":
          return {value: "Em análise", cor:"warning"}
        case "A":
          return {value: "Aprovado", cor:"success"}
        case "R":
          return {value: "Rejeitado", cor:"danger"}
      }
    },
    async incluirSolicitacao(){
      let countDespesasNaoVinculada = 0;
      try {
        const response = await this.$http.get("api/rdvCooperado/buscarDespesas/" + this.cabecalhoRdv.cd_rdv);
        const tabelaDespesasBruta = response.data;

        // Processa os dados brutos para criar a estrutura que o código original esperava
        // Identifica as transações de nível 1 (Mastercard/Visa) e associa suas despesas de nível 2
        const despesasProcessadas = tabelaDespesasBruta.filter(el => el.nivel == 1).map(el => {
            let despesasNivel2 = [];
            if (parseInt(el.id_mastercard_transacao)) {
                despesasNivel2 = tabelaDespesasBruta.filter(
                    (value) => value.nivel == 2 && parseInt(value.id_mastercard_transacao) == parseInt(el.id_mastercard_transacao)
                );
            } else if (parseInt(el.id_visa_transacao)) {
                despesasNivel2 = tabelaDespesasBruta.filter(
                    (value) => value.nivel == 2 && parseInt(value.id_visa_transacao) == parseInt(el.id_visa_transacao)
                );
            }
            return { ...el, despesas: despesasNivel2 };
        });

        // Inclui as despesas de nível 0 diretamente
        const despesasNivel0 = tabelaDespesasBruta.filter(el => el.nivel == 0);

        const todasAsDespesasParaValidacao = [...despesasProcessadas, ...despesasNivel0];

        todasAsDespesasParaValidacao.forEach((el) => {
          
          if (el.ds_tipo_carteira === "M" || el.ds_tipo_carteira === "V") {
            if (!el.sq_transacao_motivo_falta) {
              if (el.nivel === "1" && el.despesas && el.despesas.length === 0) {
                // Se for Nível 1 (Mastercard/Visa) e não tiver despesas de Nível 2 vinculadas
                const dtUsuinc = el.dt_usuinc ? new Date(el.dt_usuinc) : null;
                if (dtUsuinc) {
                  const difDias = (new Date() - dtUsuinc) / (1000 * 60 * 60 * 24);
                  if (Math.trunc(difDias) > 5) {
                    countDespesasNaoVinculada++;
                  }
                }
              }
              // Não há uma condição explícita para nível 0 com ds_tipo_carteira M ou V no seu JSON.
              // As despesas de nível 0 geralmente não teriam ds_tipo_carteira M ou V,
              // mas se elas pudessem ter, a lógica abaixo precisaria ser ajustada.
              // Pelo seu exemplo, a validação de mais de 5 dias se aplica a M/V sem vínculo.
            }
          } else if (el.nivel === "0" && el.st_lancamento === "NV" && !el.sq_transacao_motivo_falta) {
              // Se for Nível 0 (despesas avulsas), 'Não Vinculado' (NV) e sem motivo de falta
              const dtUsuinc = el.dt_usuinc ? new Date(el.dt_usuinc) : null;
              if (dtUsuinc) {
                  const difDias = (new Date() - dtUsuinc) / (1000 * 60 * 60 * 24);
                  if (Math.trunc(difDias) > 5) {
                      countDespesasNaoVinculada++;
                  }
              }
          }
        });

      } catch (err) {
        console.error("Erro ao buscar despesas para validação:", err);
        this.$tools.alerta("Ocorreu um erro ao verificar as despesas. Tente novamente.", "error");
        return; 
      }
      
      if (countDespesasNaoVinculada > 0) {
        this.$tools.alerta(
          `Existe(m) ${countDespesasNaoVinculada} transação(ões) pendente(s), sem despesa(s) vinculada(s) e/ou comprovantes anexados. Não é possível realizar a solicitação.`,
          "error"
        );
      } else {
        this.$router.push('/cooperado/rdv/carteira/adiantamento/solicitacao/incluir/'+this.$route.params.id);
      }

      // Validação inicial de adiantamento em análise
      if(!this.adtoAnalise){
        this.$tools.alerta("Já existe uma solicitação em andamento", "error");
        return;
      }
    },
    abrirModalExcluir(item) {
      this.itemParaExcluir = item;
      this.$refs.modalCancelarAdiantamento.show();
    },

    async cancelarAdiantamento(item) {
      try {
        await this.$tools.alertaConfirm("Deseja realmente Cancelar esta solicitação de Adiantamento?");
        this.loadingExcluir = true;
        await this.$http.post(`api/solicitacaoAdiantamento/cancelarSolicitacao/${item.sq_gerdviag_adto}`);
        this.$tools.alerta('Solicitação Cancelada com sucesso!', 'success');
        const novaLista = await this.buscarSolitacoes(this.$route.params.id);
        this.listaAdiantamento = Array.isArray(novaLista) ? novaLista : [];
        this.adtoAnalise = true;
        this.$router.push({ path: '/cooperado/rdv/carteira/adiantamento/solicitacao/' + this.$route.params.id });
      } catch (error) {
        this.$tools.alerta(
          'Não é possível cancelar o adiantamento<br> Só é possivel excluir uma solicitação com o status Solicitado',
          'error');
      } finally {
        this.loadingExcluir = false;
      }

    }
  }
}
</script>